import { render } from "./WorkHistoryHeader.vue?vue&type=template&id=321d04fa&scoped=true"
import script from "./WorkHistoryHeader.vue?vue&type=script&lang=js"
export * from "./WorkHistoryHeader.vue?vue&type=script&lang=js"

import "./WorkHistoryHeader.vue?vue&type=style&index=0&id=321d04fa&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321d04fa"]])

export default __exports__